/* v3.4 · Browser-built cards (Recently viewed, Wishlist, Compare) only show
   products customers can order right now. Anything else is removed, never
   shown as "Sold out" or "In development". Runs after theme.js. */
(function () {
  var cache = {};
  function available(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return !!(p && p.available); })
      .catch(function () { return false; });
    return cache[h];
  }
  function sync(list) {
    var wrap = list.closest('[data-recent-wrap]');
    if (!wrap) return;
    var any = false;
    list.querySelectorAll('.cardw').forEach(function (c) { if (c.style.display !== 'none') any = true; });
    wrap.hidden = !any;
  }
  function check(list) {
    list.querySelectorAll('.cardw').forEach(function (card) {
      if (card.dataset.v34) return;
      card.dataset.v34 = '1';
      var h = card.dataset.card;
      if (!h) return;
      card.style.display = 'none';
      available(h).then(function (ok) {
        if (ok) card.style.display = ''; else card.remove();
        sync(list);
      });
    });
    sync(list);
  }
  document.querySelectorAll('[data-product-list]').forEach(function (l) {
    new MutationObserver(function () { check(l); }).observe(l, { childList: true });
    check(l);
  });

  var table = document.querySelector('[data-compare-table]');
  function fixTable() {
    table.querySelectorAll('[data-cmp-rm]').forEach(function (btn) {
      if (btn.dataset.v34) return;
      btn.dataset.v34 = '1';
      available(btn.dataset.cmpRm).then(function (ok) { if (!ok) btn.click(); });
    });
  }
  if (table) { new MutationObserver(fixTable).observe(table, { childList: true, subtree: true }); fixTable(); }
})();
